/** Accent colors for home dashboard stat cards (hex). */
export const HOME_STAT_COLORS = {
  clubs: "#546e7a",
  members: "#37474f",
  memberships: "#78909c",
  attendances: "#90a4ae",
} as const;

/** Max rows in the recent attendances list on the home page. */
export const HOME_RECENT_ATTENDANCES_LIMIT = 8;
